import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "full-height"
}
const _hoisted_2 = { class: "base-padding column justify-between full-height" }
const _hoisted_3 = { class: "base-margin-bottom base-margin-x" }
const _hoisted_4 = { class: "base-margin-bottom base-margin-x" }
const _hoisted_5 = { class: "base-margin-bottom base-margin-x" }
const _hoisted_6 = { class: "q-pa-md col-xs-12 row items-center no-wrap justify-between" }
const _hoisted_7 = { class: "col s-divider_right_big full-height row items-center q-pr-md" }
const _hoisted_8 = { class: "col-xs-4 col-lg-2 row justify-end" }
const _hoisted_9 = { class: "col-grow row base-padding-right" }
const _hoisted_10 = { class: "self-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.type === 'table')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_q_skeleton, {
            class: "s-skeleton",
            type: "text",
            animation: "fade"
          }),
          _createVNode(_component_q_skeleton, {
            class: "s-skeleton",
            type: "text",
            animation: "fade"
          }),
          _createVNode(_component_q_skeleton, {
            class: "s-skeleton",
            type: "text",
            animation: "fade"
          })
        ], 64))
      : (_ctx.type === 'card')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_q_card, { class: "full-height" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_q_skeleton, {
                      class: "s-skeleton",
                      type: "rect",
                      animation: "fade"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_q_skeleton, {
                      class: "s-skeleton",
                      type: "rect",
                      animation: "fade"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_q_skeleton, {
                      class: "s-skeleton",
                      type: "text",
                      animation: "fade"
                    }),
                    _createVNode(_component_q_skeleton, {
                      class: "s-skeleton",
                      type: "text",
                      animation: "fade"
                    }),
                    _createVNode(_component_q_skeleton, {
                      class: "s-skeleton",
                      type: "text",
                      animation: "fade"
                    })
                  ]),
                  _createVNode(_component_q_card_actions, { class: "row justify-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_skeleton, {
                        class: "s-skeleton col-xs-12 base-margin-y",
                        type: "QBtn",
                        animation: "fade",
                        height: "44px"
                      }),
                      _createVNode(_component_q_skeleton, {
                        class: "s-skeleton col-xs-12",
                        type: "QBtn",
                        animation: "fade",
                        height: "44px"
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]))
        : (_ctx.type === 'horizontalCard')
          ? (_openBlock(), _createBlock(_component_q_card, {
              key: 2,
              class: "row justify-between items-stretch",
              style: {"height":"150px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_q_skeleton, {
                      class: "s-skeleton full-width",
                      type: "rect",
                      animation: "fade"
                    }),
                    _createVNode(_component_q_skeleton, {
                      class: "s-skeleton full-width",
                      type: "rect",
                      animation: "fade"
                    })
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["col-xs-3 q-pr-md", { hidden: _ctx.$q.screen.lt.lg }])
                  }, [
                    _createVNode(_component_q_skeleton, {
                      class: "s-skeleton base-margin-x",
                      type: "text",
                      animation: "fade"
                    }),
                    _createVNode(_component_q_skeleton, {
                      class: "s-skeleton base-margin-x",
                      type: "text",
                      animation: "fade"
                    }),
                    _createVNode(_component_q_skeleton, {
                      class: "s-skeleton base-margin-x",
                      type: "text",
                      animation: "fade"
                    }),
                    _createVNode(_component_q_skeleton, {
                      class: "s-skeleton base-margin-x",
                      type: "text",
                      animation: "fade"
                    }),
                    _createVNode(_component_q_skeleton, {
                      class: "s-skeleton base-margin-x",
                      type: "text",
                      animation: "fade"
                    })
                  ], 2),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_q_skeleton, {
                        class: "s-skeleton col-xs-12 q-mb-xs s-btn__width_256",
                        type: "QBtn",
                        animation: "fade",
                        height: "44px"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_q_btn, {
                        "no-caps": "",
                        icon: "more_vert",
                        dense: "",
                        flat: ""
                      })
                    ])
                  ])
                ])
              ]),
              _: 1
            }))
          : (_ctx.type === 'input')
            ? (_openBlock(), _createBlock(_component_q_skeleton, {
                key: 3,
                class: "s-skeleton",
                type: "QInput",
                animation: "fade"
              }))
            : _createCommentVNode("", true)
  ]))
}